/* eslint-disable no-useless-escape */

import $ from 'jquery'

import { isValidChineseNationalId, isSimplifiedChinese, isValidTaxId } from 'base/lib/international'

const default_options = {
  verboseErrors: true,
  sentenceErrors: false,
}

class Validate {
  constructor(options) {
    // Mutable error hash
    this.presence = this.presence.bind(this)
    this.maxLength = this.maxLength.bind(this)
    this.minLength = this.minLength.bind(this)
    this.pattern = this.pattern.bind(this)
    this.ccNum = this.ccNum.bind(this)
    this.cvc = this.cvc.bind(this)
    this.cardExpiry = this.cardExpiry.bind(this)
    this.errors = {}
    this.options = Object.assign({}, default_options, options)
  }

  patterns = {
    // Matches any digit(s) (i.e. 0-9)
    numeral: {
      regex: /^\d+$/,
      message: 'Please enter a whole number',
      sentenceMessage: 'should be a whole number',
    },

    // Matches any number (e.g. 100.000)
    number: {
      regex: /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/,
      message: 'Please enter a number',
      sentenceMessage: 'should be a number',
    },

    order_number: {
      regex: /^r+\d{9}/,
      message: 'Please enter your ten digit order number',
      sentenceMessage:
        'should start with the letter "r" and be followed by nine numbers, e.g. "r123456789"',
    },

    // Matches a valid email address (e.g. mail@example.com)
    email: {
      // eslint-disable-next-line no-control-regex
      regex:
        // eslint-disable-next-line no-control-regex
        /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
      message: 'Please enter a valid email',
      sentenceMessage: 'is not a valid email',
    },

    // Matches any emoji or accent char
    gift_message: {
      regex: /^[\w\d\s\``~!@#$%^&*()-_=+,./?:;"'‘’`]+$/,
      message: 'Please remove invalid characters. Valid characters include A-Z, 0-9, and (._-).',
      sentenceMessage: 'contains invalid characters',
    },

    // Matches any valid url (e.g. http://www.example.com)
    url: {
      regex:
        /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
      message: 'Please enter a valid URL',
      sentenceMessage: 'is not a valid URL',
    },

    // US Postal Code
    us_postal_code: {
      regex: /^\d{5}(?:[-\s]\d{4})?$/,
      message: 'Please enter a valid U.S. ZIP Code',
      sentenceMessage: 'is not a valid U.S. ZIP Code',
    },

    // Canadian Postal Code
    ca_postal_code: {
      regex: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/i,
      message: 'Please enter a valid Canadian Postal Code',
      sentenceMessage: 'is not a valid Canadian Postal Code',
    },

    // Chinese postal code
    cn_postal_code: {
      regex: /^\d{6}$/,
      message: 'Postal code must be 6 digits long',
      sentenceMessage: 'must be 6 digits long',
    },

    us_phone_number: {
      regex: /^(\D*\d){10}$/,
      message: 'Please enter a valid phone number',
      sentenceMessage: 'is not a valid U.S. phone number',
    },

    intl_phone_number: {
      regex: /^\s*[^+]\s*\d/,
      message: 'Phone number must not contain country code',
      sentenceMessage: 'must not contain country code',
    },

    chinese_phone_number: {
      regex: /^[1](\d\s*){10}$/,
      message: 'Please enter a valid phone number',
      sentenceMessage: 'is not a valid Chinese phone number',
    },

    latin_characters: {
      // eslint-disable-next-line no-useless-escape
      regex: /^[0-9A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/,
      message: 'We currently only accept English (Latin) characters',
      sentenceMessage: 'should be comprised of English (Latin) characters',
    },

    simplified_chinese_characters: {
      message: 'Must be in Simplified Chinese',
      sentenceMessage: 'must be in Simplified Chinese',
      test(input) {
        return isSimplifiedChinese(input)
      },
    },

    chinese_identification_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidChineseNationalId(input)
      },
    },

    br_intl_tax_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidTaxId(input, 'BR')
      },
    },

    cl_intl_tax_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidTaxId(input, 'CL')
      },
    },

    co_intl_tax_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidTaxId(input, 'CO')
      },
    },

    kr_intl_tax_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidTaxId(input, 'KR')
      },
    },

    pe_intl_tax_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidTaxId(input, 'PE')
      },
    },

    uy_intl_tax_number: {
      message: 'ID is invalid',
      sentenceMessage: 'is invalid',
      test(input) {
        return isValidTaxId(input, 'UY')
      },
    },
  }

  _validators() {
    return {
      presence: this.presence,
      maxLength: this.maxLength,
      minLength: this.minLength,
      pattern: this.pattern,
      ccNum: this.ccNum,
      cvc: this.cvc,
      cardExpiry: this.cardExpiry,
    }
  }

  // 'fieldName':
  //   value: ''
  //   validations: {any validator}
  validate(fieldsToValidate) {
    let isValid = true

    Object.keys(fieldsToValidate).forEach(field => {
      const validationData = fieldsToValidate[field]
      const { value, label, validations } = validationData

      Object.keys(validations).forEach(type => {
        const validation = validations[type]
        const isFieldValid = this._validators()[type](value, validation, field, label)

        if (isFieldValid === false) {
          isValid = false
        }
      })
    })

    return isValid
  }

  _setError(message, validation, field) {
    this.errors[field] = this.errors[field] || {}

    if (this.options.verboseErrors) {
      // Expanded object of all validations on field
      this.errors[field][validation] = message
    } else {
      this.errors[field] = message // The message of the final failed validation
    }
  }

  getErrors() {
    const computedErrors = this.errors

    return Object.keys(this.errors).reduce((errors, field) => {
      errors[field] = computedErrors[field].message

      return errors
    }, {})
  }

  getSentenceErrors() {
    const invertedIndex = Object.values(this.errors).reduce((errors, error) => {
      const message = error.sentenceMessage
      const labels = errors[message] || []

      return Object.assign({}, errors, {
        [message]: [...Array.from(labels), error.label],
      })
    }, {})

    const formattedErrors = Object.entries(invertedIndex).map(([error, labels]) => {
      const formattedError = labels.length > 1 ? error.replace(/^is/, 'are') : error

      const separator = labels.length > 2 ? ', ' : ' and '

      return `${labels.join(separator)} ${formattedError}`
    })

    return formattedErrors.map(error => {
      const lastCommaIndex = error.lastIndexOf(',')

      const formattedError =
        lastCommaIndex > -1
          ? `${error.slice(0, lastCommaIndex + 2)} and ${error.slice(lastCommaIndex + 2)}`
          : error

      return `${formattedError}.`
    })
  }

  clearErrors() {
    this.errors = {}
  }

  // Returns true if the value is not empty
  presence(value, required, field, label) {
    if (required && (!value || !value.trim())) {
      const error = {
        label,
        message: 'Required',
        sentenceMessage: 'is required',
      }
      this._setError(error, 'presence', field)

      return false
    } else {
      return true
    }
  }

  // Returns true if the value is under the max length
  maxLength(value, maxLength, field, label) {
    if (!value) return true

    if (value.length > maxLength) {
      const error = {
        label,
        message: `Must be at most ${maxLength} characters`,
        sentenceMessage: `must be at most ${maxLength} characters`,
      }
      this._setError(error, 'maxLength', field)

      return false
    } else {
      return true
    }
  }

  // Returns true if the value is over the min length
  minLength(value, minLength, field, label) {
    if (value.length < minLength) {
      const error = {
        label,
        message: `Must be at least ${minLength} characters`,
        sentenceMessage: `must be at least ${minLength} characters`,
      }
      this._setError(error, 'minLength', field)

      return false
    } else {
      return true
    }
  }

  // Returns true if regex or test func passes
  pattern(value, pattern, field, label) {
    if (!value || !value.length || !pattern) return

    const patterns = Array.isArray(pattern) ? pattern : Array.of(pattern)

    return patterns.every(currentPattern => {
      const matchedPattern = this.patterns[currentPattern]

      if (matchedPattern.test && matchedPattern.test(value)) {
        return true
      } else if (matchedPattern.regex && matchedPattern.regex.test(value)) {
        return true
      } else {
        const error = {
          label,
          message: matchedPattern.message,
          sentenceMessage: matchedPattern.sentenceMessage,
        }
        this._setError(error, 'pattern', field)

        return false
      }
    })
  }

  // Returns true if the value is a valid credit card number
  ccNum(value, trueValue, field, label) {
    if (!value.length) return

    if (!$.payment.validateCardNumber(value)) {
      const error = {
        label,
        message: 'Invalid card number',
        sentenceMessage: 'is invalid',
      }
      this._setError(error, 'ccNum', field)

      return false
    } else {
      return true
    }
  }

  // Returns true if the value is a valid CVC
  cvc(value, ccNumSelector, field, label) {
    if (!value.length) return

    if ($.payment.validateCardCVC(value, $.payment.cardType($(ccNumSelector).val()))) {
      return true
    }
    const error = {
      label,
      message: 'Invalid CVC',
      sentenceMessage: 'is invalid',
    }
    this._setError(error, 'cvc', field)

    return false
  }

  // Returns true if the value is a valid credit card expiration date
  cardExpiry(value, trueValue, field, label) {
    if (!value.length) return

    const expiry = $.payment.cardExpiryVal(value)
    if (!$.payment.validateCardExpiry(expiry.month, expiry.year)) {
      const error = {
        label,
        message: 'Invalid',
        sentenceMessage: 'is invalid',
      }
      this._setError(error, 'cardExpiry', field)

      return false
    } else {
      return true
    }
  }
}

export default Validate
